import { useEffect, useCallback, useRef } from "react";

function useThrottle(fn, delay, dep = []) {
  const { current } = useRef({ fn, timer: null, starttime: Date.now() });
  useEffect(
    function () {
      current.fn = fn;
    },
    [fn]
  );

  return useCallback(function f(...args) {
    let curTime = Date.now(); // 当前时间
    let remaining = delay - (curTime - current.starttime); // 从上一次到现在，还剩下多少多余时间
    clearTimeout(current.timer);
    if (remaining <= 0) {
      current.fn.apply(this, args);
      current.starttime = Date.now();
    } else {
      current.timer = setTimeout(current.fn, remaining);
    }
    // if (!current.timer) {
    //   current.timer = setTimeout(() => {
    //     delete current.timer;
    //   }, delay);
    //   current.fn.call(this, ...args);
    // }
  }, dep);
}

export default useThrottle;
